import { Component, OnDestroy, OnInit } from '@angular/core';
import { SamwebBrick } from '../../samweb-brick.decorator';
import { faWeight } from '@fortawesome/pro-duotone-svg-icons';
import { BrickCategory } from '../../../../samwebDescription/samweb/brickCategoryType';
import { Observable } from 'rxjs';
import { Select, Store } from '@ngxs/store';
import { LoadTestState } from '../../../../store/utility/load-test/load-test.state';
import { StartLoadTestMode, StopLoadTestMode } from '../../../../store/utility/load-test/load-test.actions';
import { BasicBrickComponent } from '../../basic-brick-component';

@Component({
   selector: 'samweb-load-test-brick',
   templateUrl: './load-test-brick.component.html',
   styleUrls: ['./load-test-brick.component.scss'],
})
@SamwebBrick({
   brickDefinitionId: 'loadTest',
   brickTitleTranslationKey: 'brick.brick_definitions.load_test.title',
   brickDescriptionTranslationKey: 'brick.brick_definitions.load_test.description',
   brickIcon: faWeight,
   minColWidth: 25,
   minRowHeight: 10,
   brickCategory: BrickCategory.DEBUG,
})
export class LoadTestBrickComponent extends BasicBrickComponent implements OnInit, OnDestroy {
   constructor(private store: Store) {
      super();
   }

   brickInstanceId: Readonly<string>;

   @Select(LoadTestState.isLoadTestModeEnabled)
   public isLoadTestModeEnabled$: Observable<boolean>;

   ngOnInit(): void {
      this.store.dispatch(new StartLoadTestMode());
   }

   ngOnDestroy(): void {
      this.store.dispatch(new StopLoadTestMode());
   }

   toggleLoadTestEnabled(shouldBeEnabled: boolean) {
      if (shouldBeEnabled) {
         this.store.dispatch(new StartLoadTestMode());
      } else {
         this.store.dispatch(new StopLoadTestMode());
      }
   }
}
